var amdi18n={"__root":{"show_cloud_identity":"Show Cloud Identity","manage_cloud_identity":"Manage Cloud Identity","renew_cloud_identity":"Renew Cloud Identity","extend_cloud_identity":"Extend Cloud Identity","transfer_cloud_identity":"Transfer Cloud Identity","export_cloud_identity":"Export Cloud Identity","encrypt_cloud_identity":"Protect Cloud Identity with PIN","decrypt_cloud_identity":"Remove PIN from Cloud Identity","delete_cloud_identity":"Delete Cloud Identity","insert_pin":"Insert PIN for Cloud Identity","encrypt_cloud_identity_before_transfer":"Protect Cloud Identity with PIN before Transfer","save_cloud_identity":"Save Cloud Identity","activate_fido":"Please insert FIDO-Token and if needed, please touch the token."},"__de":{"show_cloud_identity":"Cloud Identität anzeigen","manage_cloud_identity":"Cloud Identität verwalten","renew_cloud_identity":"Cloud Identität erneuern","extend_cloud_identity":"Cloud Identität erweitern","transfer_cloud_identity":"Cloud Identität tranferieren","export_cloud_identity":"Cloud Identität exportieren","encrypt_cloud_identity":"Cloud Identität mit PIN schützen","decrypt_cloud_identity":"PIN-Schutz für Cloud Identität aufheben","delete_cloud_identity":"Cloud Identität löschen","insert_pin":"PIN für Cloud Identität eingeben","encrypt_cloud_identity_before_transfer":"Cloud Identität vor Transfer mit PIN schützen","save_cloud_identity":"Cloud Identität speichern","activate_fido":"Bitte FIDO-Token stecken und ggf berühren."}};amdi18n.init=function(language){
		// get the default language
		if(!language){
			if(window._i18n && window._i18n.locale){
				language = window._i18n.locale;
			}else if(document.documentElement.lang){
				language = document.documentElement.lang;
			}else{
				language = 'root';
			}
		}
		var target = this['__' + language] || this.__root;

		// copy definition to root level
		if (target) {
			for (var name in target) {
				this[name] = target[name];
			}
		}

		// fallback to root
		for(var name in this.__root){
			if(typeof this[name] === 'undefined'){
				this[name] = this.__root[name];
			}
		}
	};amdi18n.init();module.exports=amdi18n;


//////////////////
// WEBPACK FOOTER
// ./node_modules/amdi18n-loader!./src/main/web/js/app/state/nls/IdentityManagementState_strings.js
// module id = 165
// module chunks = 2